import React, { useEffect, useState } from "react";
import { getApiUrl, BASE_URL } from "../utils/api";
import Homeslider from "../components/Homeslider";
import { useNavigate } from "react-router-dom";
import ContactContainer from "../components/Containercontact";
import ProductCard from "../components/ProductCard";
import Sampletext from "../components/Sampletext";

const Home = () => {
  const navigate = useNavigate();

  const [products, setProducts] = useState({});
  const [subcategories, setSubcategories] = useState([]);
  const [categories, setCategories] = useState([]);

  /* ---------------- GUEST USER ---------------- */
  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      const guestId =
        "guest_" + Date.now() + "_" + Math.floor(Math.random() * 10000);
      localStorage.setItem("userId", guestId);
    }
  }, []);

  /* ---------------- PRODUCTS ---------------- */
  const fetchProducts = async () => {
    try {
      const res = await fetch(getApiUrl("product-ui-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      });

      const result = await res.json();

      if (result.success) {
        const grouped = {};

        result.data.forEach((p) => {
          const category = p.categoryId?.name || "Others";
          const subName = p.subcategoryId?.name || "General";
          const subId = p.subcategoryId?._id || null;

          if (!grouped[category]) grouped[category] = {};

          if (!grouped[category][subName]) {
            grouped[category][subName] = {
              subcategoryId: subId,
              items: [],
            };
          }

          grouped[category][subName].items.push({
            id: p._id,
            productName: p.productName,
            mainImage: p.mainImage,
            price: p.price,
            originalPrice: p.originalPrice,
            slugUrl: p.slugUrl,
            discount: p.discount,
            description: p.description,
            totalProducts: p.totalProducts,
            sizes: p.sizes,
          });
        });

        setProducts(grouped);
      }
    } catch (err) {
      console.error("Product API Error:", err);
    }
  };

  /* ---------------- SUBCATEGORIES ---------------- */
  const fetchSubcategories = async () => {
    try {
      const res = await fetch(getApiUrl("subcat-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      });

      const result = await res.json();

      if (result.success) {
        const subs = result.data.map((sub) => {
          let image = sub.imageUrl || "";
          if (image && !image.startsWith("http")) {
            image = `${BASE_URL}/${image.replace(/^\/+/, "")}`;
          }
          return {
            id: sub._id,
            name: sub.name,
            image,
          };
        });

        setSubcategories(subs);
      }
    } catch (err) {
      console.error("Subcategory API Error:", err);
    }
  };

  /* ---------------- CATEGORIES ---------------- */
  const fetchCategories = async () => {
    try {
      const res = await fetch(getApiUrl("category-ui-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      });

      const result = await res.json();

      if (result.success) {
        const cats = result.data.map((cat) => {
          let image = cat.imageUrl || "";
          if (image && !image.startsWith("http")) {
            image = `${BASE_URL}/${image.replace(/^\/+/, "")}`;
          }
          return {
            id: cat._id,
            name: cat.name,
            image,
          };
        });

        setCategories(cats);
      }
    } catch (error) {
      console.error("Category API Error:", error);
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchSubcategories();
    fetchCategories();
  }, []);

  return (
    <div>
      {/* ---------------- SLIDER ---------------- */}
      <div className="w-100">
        <Homeslider />
      </div>

      {/* ---------------- SHOP BY CATEGORY ---------------- */}
      <div className="container pt-4 p-2">
        <h5 className="mb-3 fw-bold">Shop by Category</h5>
        <div className="row g-3 justify-content-center">
          {categories.map((cat) => (
            <div key={cat.id} className="col-6 col-md-3 text-center">
              <div
                className="sub-tile"
                onClick={() =>
                  navigate("/bsk-main-product", {
                    state: { categoryId: cat.id },
                  })
                }
              >
                <div className="cat-image">
                  <img src={cat.image} alt={cat.name} />
                </div>
                <div className="sub-name">{cat.name}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ---------------- SHOP BY SUBCATEGORY ---------------- */}
      <div className="container pt-4 p-2">
        <h5 className="mb-3 fw-bold">Shop by Subcategory</h5>
        <div className="row g-3">
          {subcategories.map((sub) => (
            <div key={sub.id} className="col-6 col-md-3 text-center">
              <div
                className="sub-tile"
                onClick={() =>
                  navigate("/bsk-main-product", {
                    state: { subcategoryId: sub.id },
                  })
                }
              >
                <div className="sub-image">
                  <img src={sub.image} alt={sub.name} />
                </div>
                <div className="sub-name">{sub.name}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ---------------- PRODUCTS (LIMIT 8) ---------------- */}
      <div className="home section">
        <div className="container ps-lg-5 ps-3">
          {Object.keys(products).length > 0 ? (
            Object.keys(products).map((cat) => (
              <div key={cat} className="mb-5">
                <h2 className="py-3">{cat}</h2>

                {Object.keys(products[cat]).map((sub) => {
                  const subData = products[cat][sub];

                  return (
                    <div key={sub} className="mb-4">
                      <div className="d-flex justify-content-between align-items-center px-2">
                        <h4>{sub}</h4>
                        <button
                          className="btn btn-sm btn-outline-dark"
                          onClick={() =>
                            navigate("/bsk-main-product", {
                              state: {
                                subcategoryId: subData.subcategoryId,
                              },
                            })
                          }
                        >
                          View All →
                        </button>
                      </div>

                      <div className="row g-3 mt-2">
                        {subData.items.slice(0, 8).map((product) => (
                          <div
                            key={product.id}
                            className="col-6 col-md-3 col-lg-2"
                          >
                            <ProductCard product={product} />
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            ))
          ) : (
            <h5 className="text-center py-5">Loading...</h5>
          )}
        </div>

        <Sampletext />
        <ContactContainer />
      </div>
    </div>
  );
};

export default Home;
